import Detail from './detail'

export default Detail
